import pjson from '../package.json';
import bootstrap from './bootstrap';

window.desktop?.logger?.info?.(
  `App name ${pjson.name} version - ${pjson.version}`
);

bootstrap(Function.prototype);
